const logoImage = "/assets/logo/aiscendus-white-bg.png";

export default function Footer() {
  return (
    <footer className="bg-muted/50 border-t">
      <div className="w-full py-8 px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6 md:gap-8">
          {/* Company Info */}
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <img 
                src={logoImage} 
                alt="AIscendus Logo" 
                className="h-10 w-auto rounded-lg"
                data-testid="img-footer-logo"
              />
            </div>
            <p className="text-sm text-muted-foreground max-w-xs" data-testid="text-footer-description">
              Transforming healthcare through intelligent AI solutions that improve patient outcomes and support clinical decision-making.
            </p>
          </div>

          {/* Solutions */}
          <div className="space-y-3">
            <h3 className="font-semibold text-foreground" data-testid="text-solutions-heading">Solutions</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/solutions/clinical" className="hover:text-foreground transition-colors" data-testid="link-clinical">Clinical</a></li>
              <li><a href="/solutions/occupational-medicine" className="hover:text-foreground transition-colors" data-testid="link-occupational-medicine">Occupational Medicine</a></li>
              <li><a href="/solutions/practice-management" className="hover:text-foreground transition-colors" data-testid="link-practice-management">Practice Management</a></li>
              <li><a href="/solutions/revenue-cycle-management" className="hover:text-foreground transition-colors" data-testid="link-revenue-cycle">Revenue Cycle Management</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div className="space-y-3">
            <h3 className="font-semibold text-foreground" data-testid="text-resources-heading">Resources</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/news" className="hover:text-foreground transition-colors" data-testid="link-news">News</a></li>
              <li><a href="/careers" className="hover:text-foreground transition-colors" data-testid="link-careers">Careers</a></li>
              <li><a href="/blogs" className="hover:text-foreground transition-colors" data-testid="link-blogs">Blogs</a></li>
            </ul>
          </div>

          {/* About */}
          <div className="space-y-3">
            <h3 className="font-semibold text-foreground" data-testid="text-about-heading">About</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/contact" className="hover:text-foreground transition-colors" data-testid="link-contact-footer">Contact</a></li>
            </ul>
          </div>

          {/* Platform */}
          <div className="space-y-3">
            <h3 className="font-semibold text-foreground" data-testid="text-platform-heading">Platform</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/platform" className="hover:text-foreground transition-colors" data-testid="link-platform-footer">Platform</a></li>
              <li><a href="/book-demo" className="hover:text-foreground transition-colors" data-testid="link-book-demo-footer">Book Demo</a></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-3">
            <h3 className="font-semibold text-foreground" data-testid="text-legal-heading">Legal & Compliance</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/privacy-policy" className="hover:text-foreground transition-colors" data-testid="link-privacy">Privacy Policy</a></li>
              <li><a href="/terms-of-service" className="hover:text-foreground transition-colors" data-testid="link-terms">Terms of Service</a></li>
              <li><a href="/hipaa-compliance" className="hover:text-foreground transition-colors" data-testid="link-hipaa">HIPAA Compliance</a></li>
              <li><a href="/security" className="hover:text-foreground transition-colors" data-testid="link-security">Security</a></li>
            </ul>
          </div>
        </div>

        <p className="mt-6 text-left text-sm text-muted-foreground" data-testid="text-copyright">
          © 2026 AIscendus Healthcare Solutions. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

